import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import JournalResult from './JournalResult';
import ManageJournal from './ManageJournal';
import JournalViewResult from './JournalViewResult';
import ViewJournalResult from './ViewJournalResult';
import ErrorBoundary from '../../ErrorBoundary';

class JournalTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            showHomeEnityName: localStorage.getItem("homeEntityName"),
            patientAdmissionHeading: ''

        }
        window.journalNavBarController = this;
    }
    componentDidMount() {
        this.paintPatientAdmissionHeading();
        (function () {
            var currentPath = window.location.href;

            var path = window.origin + "/my-jeeva/projectmgmt/journal";
            var path1 = window.origin + "/my-jeeva/projectmgmt/journal/";
            if (currentPath == path || currentPath == path1) {
                $("#new-journal").addClass('active');
            } else if (currentPath.includes('/projectmgmt/journal') ||
                currentPath.includes('/projectmgmt/journal')) {
                $("#manage-journal").addClass('active');
            } else if (currentPath.includes('/projectmgmt/journal/view-result') ||
                currentPath.includes('/projectmgmt/journal/view-result/')) {
                $("#view-result").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-project-journal-tab")).addClass('active')
            }
            $("#new-journal,#manage-journal,#view-result")
                .on("click", function () {
                    $("#new-journal,#manage-journal,#view-result")
                        .removeClass('active');
                    localStorage.setItem("last-project-about-tab", $(this)[0].id);

                    $(this).addClass('active')

                })

        })();
    }
    paintPatientAdmissionHeading = () => {
        var healthSystemName = localStorage.getItem('healthSystemName');
        var hospitalName = localStorage.getItem('hospitalName');
        var serviceLineName = localStorage.getItem('serviceName');

        if (healthSystemName == "Select Health System" || healthSystemName == "null") {
            healthSystemName = null;
        }
        if ((hospitalName == "Select Hospital") || (hospitalName == "null")) {
            hospitalName = null;
        }
        if ((serviceLineName == "Select Service Line") || (serviceLineName == "null")) {
            serviceLineName = null;
        }

        var heading = "";
        if (healthSystemName) {
            heading = healthSystemName;
            if (hospitalName) {
                heading = hospitalName + " | " + heading;
                // if (serviceLineName) {
                //     heading = serviceLineName + " | " + heading;
                // }
            }
        }
        this.state.patientAdmissionHeading = heading;
        this.setState(this.state);
    }


    render() {
        return (
            <ErrorBoundary>
            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="content-header" >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-4">
                                    <h1 className="m-0 page-title">Journals</h1>
                                </div>
                                <div className="col-sm-8" style={{ textAlign: 'right' }}>
                                    <h1 className="m-0 page-title" style={{ textAlign: 'right' }}>
                                        {window.SCOPE_VALUE.CURRENT == 10 ? this.state.patientAdmissionHeading : this.state.showHomeEnityName}

                                    </h1>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="border-bottom"></div>
                        <div className="tab-class">

                            <ul className="nav nav-tabs border-bottom navCluster">

                                {/* <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/journal" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="new-journal" style={{ marginRight: '15px' }}>
                                        Schedule a Journal
                                    </li>
                                </Link> */}
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/journal" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="new-journal" style={{ marginRight: '15px' }}>
                                        Configure Journal
                                    </li>
                                </Link>
                                {/* <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/journal/view-result" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="view-result" style={{ marginRight: '15px' }}>
                                        View Results
                                    </li>
                                </Link> */}

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch> 
                    <Route exact path="/projectmgmt/journal" component={ManageJournal}></Route>
                    <Route path="/projectmgmt/journal/view-result" component={ViewJournalResult}></Route>
                  <Route  path="/projectmgmt/journal/view-patient-journal-results"
                        component={JournalViewResult}></Route>
                    {/* <Route path="/projectmgmt/journal" component={JournalContent}></Route> */}
                    {/* <Route path="/projectmgmt/journal/view-result" component={JournalResult}></Route> */}

                </Switch>
            </div>
            </ErrorBoundary>
        );
    }
}
export default JournalTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/JournalTabSettings.js